export default {
  headerContent: {
    title: 'Sompo Sigorta Zorunlu Trafik Sigortası Teklif Al',
    slogan: "Trafik Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'TRAFİK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Sompo  Sigorta Zorunlu Trafik Sigortası',
    description: {
      title: 'Sompo  Sigorta Zorunlu Trafik Sigortası Nedir? ',
      content: [
        'Trafikte olduğunuz her an risklerle karşı karşıya olduğunuzu bilmelisiniz. Trafikte karışacağınız bir kaza sonucunda karşı tarafa vereceğiniz zararları güvence altına almanız için Sompo Sigorta yanınızda!',
        'Kusurlu olduğunuz bir kaza nedeniyle karşı sürücüde oluşan masrafları karşılayan sorumluluk sigortasına verilen üründür. Tipik olarak bedensel yaralanma yükümlülüğü ve mal hasarı sorumluluk teminatlarını içerir.',
        'Kaza anında karşı tarafa veya 3. Şahıslara vereceğiniz hasarlardan doğan sorumluluklarınızı Sompo Sigorta trafik sigortası ile güvence altına alabilirsiniz.'
      ]
    },
    subContent: {
      title: 'Sompo Sigorta Zorunlu Trafik Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Trafik sigortası kaza sonucu karşı tarafın uğrayacağı hasarları poliçe de belirtilmiş limitler dâhilinde kapsar. Bu doğrultuda meydana gelen zarar ve hasarlar sigorta şirketi tarafından karşılanır.',
          subList: null
        },
        {
          paragraph:
            'Bir araba kazasına neden olursanız, trafik sigortası hasarı, yaralanma veya vefat masraflarını kapsar.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Trafik Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Trafik Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Trafik Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Trafik Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Trafik Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Sompo  Sigorta Trafik Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
